import React, { Component } from "react";
import { auth } from "../../../utils/auth";
import Form from "./Form";
import { apiUrl } from "../../../utils/apiUrl";
import { postRequest } from "../../../utils/request";

class Create extends Component {
    state = {
        errors: {},
        almacen: {}
    };
    createAlmacen = async event => {
        event.preventDefault();

        const data = new FormData(event.target);
        const response = await postRequest(apiUrl("almacenes"), data);

        if (response.success) {
            this.props.getAlmacenes();
            this.props.toggle();
        }
        if (response.code === 422) {
            this.setState({ errors: response.data.message });
        }
    };
    render() {
        const { errors, almacen } = this.state;
        const { toggle } = this.props;
        return (
            <form method='post' onSubmit={this.createAlmacen}>
                <div className='popup__header'>Nuevo Almacen</div>
                <div className='popup__body'>
                    <Form almacen={almacen} errors={errors} />
                </div>
                <div className='popup__footer'>
                    <button
                        type='button'
                        onClick={toggle}
                        className='btn btn-plain'>
                        Cancelar
                    </button>
                    <button type='submit' className='btn btn-primary'>
                        Crear
                    </button>
                </div>
            </form>
        );
    }
}

export default Create;
